import { PLAN_TYPES } from "../constants/subscriptionPricing";
import {
  calculateBillingSummary,
  createInitialSeats,
} from "./subscriptionBilling";

const CHECKOUT_STORAGE_KEY = "seismic_checkout_summary";

export function saveCheckoutSession({ planType, seats }) {
  const summary = calculateBillingSummary({ planType, seats });
  const payload = {
    planType,
    seats,
    summary,
    savedAt: new Date().toISOString(),
  };
  sessionStorage.setItem(CHECKOUT_STORAGE_KEY, JSON.stringify(payload));
  return payload;
}

export function loadCheckoutSession() {
  try {
    const raw = sessionStorage.getItem(CHECKOUT_STORAGE_KEY);
    if (!raw) return null;
    const parsed = JSON.parse(raw);
    if (!parsed?.summary?.lineItems) return null;
    return parsed;
  } catch {
    return null;
  }
}

export function getDefaultCheckoutSession() {
  return saveCheckoutSession({
    planType: PLAN_TYPES.WITHOUT_EHR,
    seats: createInitialSeats(),
  });
}
